import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { CompanyService } from 'src/app/company/company.service';
import { Role } from 'src/app/shared/models/user-model';
import { isProgressPage as isProgressPageUtil } from '../../shared/utils/navigation-utils';

@Component({
    selector: 'app-wrapper',
    templateUrl: './wrapper.component.html',
    styleUrls: ['./wrapper.component.scss'],
    standalone: false
})
export class WrapperComponent implements OnInit {
  hasAdminRole = false;
  currrWidth = window.innerWidth;
  constructor(
    private app: AppService,
    private router: Router,
    private companyService: CompanyService
  ) {}
  ngOnInit(): void {
    if (this.app.hasRole(Role.Admin)) {
      this.hasAdminRole = true;
    }
  }

  isFaqPanelOpen = false;

  toggleFaqPanel(event: Event): void {
    event.preventDefault();
    this.isFaqPanelOpen = !this.isFaqPanelOpen;
    document.body.style.overflow = this.isFaqPanelOpen ? 'hidden' : 'auto';
    if (this.isFaqPanelOpen) {
      window.scrollTo(0, 0);
    }
  }

  closeFaqPanel(): void {
    this.isFaqPanelOpen = false;
    document.body.style.overflow = 'auto';
  }

  isListPage(): boolean {
    const currentUrl = this.router.url.split('?')[0];
    return (
      currentUrl.endsWith('/dboard') ||
      currentUrl.endsWith('/addcompanymodal') ||
      currentUrl.endsWith('/requests') ||
      currentUrl.endsWith('/emailpreview') ||
      currentUrl.endsWith('/apifailure')
    );
  }

  isWorkFlowPage(): boolean {
    const currentUrl = this.router.url.split('?')[0];
    return (
      currentUrl.endsWith('/companyinformation') ||
      currentUrl.endsWith('/groupreporting') ||
      currentUrl.endsWith('/annualstatement') ||
      currentUrl.endsWith('/premiumreport') ||
      currentUrl.endsWith('/validationsummary') ||
      currentUrl.endsWith('/userdefineddata')
    );
  }

  getcurrentUrlSegment(): string {
    const currentUrl = this.router.url.split('?')[0];
    const segments = currentUrl.split('/');
    return segments[segments.length - 1];
  }

  openSectionHelpDocument(): void {
    const currentSection = this.getcurrentUrlSegment();
    const documentName = `ScreenHelp-${
      currentSection.charAt(0).toUpperCase() + currentSection.slice(1)
    }.pdf`;

    this.companyService.getTemplateFile(documentName).subscribe({
      next: (response: any) => {
        if (response.message === 'Success' && response.templateurl) {
          window.open(response.templateurl, '_blank');
        } else {
          console.warn(`No help document found for ${currentSection}`);
        }
      },
      error: () => {
        this.router.navigate(['/apifailure']);
      },
    });
  }
  isProgressPage(): boolean {
    return isProgressPageUtil(this.router.url);
  }
}
